"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addContactSaga = void 0;
const effects_1 = require("redux-saga/effects");
const addContactEmailExchangeCodeSaga_1 = require("./addContactEmailExchangeCodeSaga");
const addContactEmailResendCodeSaga_1 = require("./addContactEmailResendCodeSaga");
const addContactEmailSendCodeSaga_1 = require("./addContactEmailSendCodeSaga");
const addContactPhoneExchangeCodeSaga_1 = require("./addContactPhoneExchangeCodeSaga");
const addContactPhoneResendCodeSaga_1 = require("./addContactPhoneResendCodeSaga");
const addContactPhoneSendCodeSaga_1 = require("./addContactPhoneSendCodeSaga");
function* addContactSaga() {
    // email
    yield (0, effects_1.takeLatest)(addContactEmailSendCodeSaga_1.addContactEmailSendCode.toString(), addContactEmailSendCodeSaga_1.addContactEmailSendCodeSaga);
    yield (0, effects_1.takeLatest)(addContactEmailExchangeCodeSaga_1.addContactEmailExchangeCode.toString(), addContactEmailExchangeCodeSaga_1.addContactEmailExchangeCodeSaga);
    yield (0, effects_1.takeLatest)(addContactEmailResendCodeSaga_1.addContactEmailResendCode.toString(), addContactEmailResendCodeSaga_1.addContactEmailResendCodeSaga);
    // phone
    yield (0, effects_1.takeLatest)(addContactPhoneSendCodeSaga_1.addContactPhoneSendCode.toString(), addContactPhoneSendCodeSaga_1.addContactPhoneSendCodeSaga);
    yield (0, effects_1.takeLatest)(addContactPhoneExchangeCodeSaga_1.addContactPhoneExchangeCode.toString(), addContactPhoneExchangeCodeSaga_1.addContactPhoneExchangeCodeSaga);
    yield (0, effects_1.takeLatest)(addContactPhoneResendCodeSaga_1.addContactPhoneResendCode.toString(), addContactPhoneResendCodeSaga_1.addContactPhoneResendCodeSaga);
}
exports.addContactSaga = addContactSaga;
